import { Flex, useStyleConfig, VisuallyHidden } from '@chakra-ui/react';
import { PriceVATMessage } from 'components/common/PriceVATMessage';
import { FormatPrice } from 'components/localisation/FormatPrice';
import type { Cart } from 'types/cart/Cart';

type PricingProps = Pick<Cart, 'cost' | 'totalPrice' | 'subTotal'> & {
  hasDiscount: boolean;
};

export function Pricing({
  cost,
  totalPrice,
  subTotal,
  hasDiscount,
}: PricingProps) {
  const styles = useStyleConfig('Text', { size: 'detail' });

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      sx={{
        '.decimal': { ...styles, fontWeight: 'medium' },
      }}
    >
      {cost && (
        <Flex gap="3xs">
          <VisuallyHidden>Now </VisuallyHidden>
          <FormatPrice
            className="price--now"
            size="h4"
            fontWeight="medium"
            amount={totalPrice.amount}
          />
          {hasDiscount && (
            <>
              <VisuallyHidden>Was </VisuallyHidden>
              <FormatPrice
                className="price--was"
                size="h4"
                fontWeight="medium"
                color="gray.600"
                opacity={0.36}
                hasStrikeThrough
                amount={subTotal.amount}
              />
              <FormatPrice
                className="price--saved"
                pb="2px"
                alignSelf="flex-end"
                fontWeight="medium"
                color="red.300"
                size="detail"
                amount={subTotal.amount - totalPrice.amount}
                beforeText="Save "
              />
            </>
          )}
        </Flex>
      )}
      {!cost && totalPrice && (
        <FormatPrice
          className="price--total"
          size="h4"
          fontWeight="medium"
          amount={totalPrice.amount}
        />
      )}
      <PriceVATMessage
        beforeText="Prices"
        size="detail"
        color="blackAlpha.700"
        textAlign="center"
        pb="2px"
        alignSelf="flex-end"
      />
    </Flex>
  );
}
